import { FunctionComponent } from 'react';
import styles from './section7.module.css';


const Section7: FunctionComponent = () => {
	return (
		<div className={styles.builtForAmbitiousLendersParent} style={{ marginTop: "340px" }}>
			<div className={styles.builtForAmbitious}>Built For Ambitious Lenders</div>
			<div className={styles.trustedByClients}>Trusted by clients and wellness partners from world’s leading organisations.</div>
			<div className={styles.frameParent}>
				<div className={styles.kParent}>
					<div className={styles.k1}>1Mn+</div>
					<div className={styles.aiBotMinutes}>AI Bot Minutes</div>
				</div>
				<div className={styles.kParent}>
					<div className={styles.k1}>100k+</div>
					<div className={styles.aiBotMinutes}>Skip Traced</div>
				</div>
				<div className={styles.kParent}>
					<div className={styles.k1}>2500+</div>
					<div className={styles.aiBotMinutes}>Jatayu Field Force</div>
				</div>
				<div className={styles.kParent}>
					<div className={styles.k1}>30K+</div>
					<div className={styles.aiBotMinutes}>Escalations Avoided</div>
				</div>
			</div>
			{/* <div style={{ height: "100vh", width: "70%", overflowY: "scroll" }}>
				<Movable />
			</div> */}


		</div>
	);
};

export default Section7;
